import { useSelector } from "react-redux";
import { dispatch } from "app/store/store";
import {
  GetDashboardPreInfoDataThunk,
  resetSupplyDashboardSliceData,
  updateDashboardType,
} from "app/store/slice/supply-dashboard-slice";
import { unwrapResult } from "@reduxjs/toolkit";
import { useEffect } from "react";
import { Box, CircularProgress } from "@mui/material";
import SupplyDashboard from "./SupplyDashboard";

const BidderSupplyDashboard = () => {
  let profile_type = window.location.pathname.split("/")[1];
  const { authUserData } = useSelector((state) => state.CommonReducer);
  const { dashboardPreInfo } = useSelector(
    (state) => state.SupplyDashboardReducer
  );

  const getDashboardPreInfo = (type) => {
    let payload = {
      dataview: profile_type,
      dashboadType: "supply",
      userData: {
        is_sys_admin: authUserData.is_sys_admin,
        user_id: authUserData.user_id,
        show_publisher_tile: false,
      },
    };

    dispatch(GetDashboardPreInfoDataThunk(payload))
      .then(unwrapResult)
      .then((res) => {});
  };

  useEffect(() => {
    getDashboardPreInfo();
    //dispatch(updateDashboardType({ dashboardType: profile_type }));
    // return () => {
    //   dispatch(resetAnalyticsDashboardSliceData());
    // };
  }, []);

  return (
    <>
      {(Object.keys(dashboardPreInfo).length <= 0 ||
        dashboardPreInfo?.dashboardType != profile_type) && (
        <Box sx={{ position: "relative" }}>
          <CircularProgress
            sx={{
              zIndex: 4,
              position: "absolute",
              top: (window.innerHeight - 130) / 2 + "px",
              left: "50%",
              transform: "translate(-50%, -50%)",
              transform: "-webkit-translate(-50%, -50%)",
              transform: "-moz-translate(-50%, -50%)",
              transform: "-ms-translate(-50%, -50%)",
            }}
          />
        </Box>
      )}

      {Object.keys(dashboardPreInfo).length > 0 &&
        dashboardPreInfo?.dashboardType == profile_type && (
          <SupplyDashboard
            profile_type={profile_type}
            dashboardPreInfo={dashboardPreInfo}
          />
        )}
    </>
  );
};
export default BidderSupplyDashboard;
